let ProjectedOwnershipCap = {
    PROJECTED_OWNERSHIP_CAP_SET_INNER: 'PROJECTED_OWNERSHIP_CAP_SET_INNER',

    DEFAULT_VALUE_FOR_MAX_PROJECTED_OWNERSHIP_CAP: 900,
    DEFAULT_VALUE_FOR_MIN_PROJECTED_OWNERSHIP_CAP: 0,
};

export default ProjectedOwnershipCap;
